import { lazy } from "react";

export { ADMIN_PANEL_ROLES_PATH } from "./roles-path";
export const Roles = lazy(() => import("./roles"));
